export default __webpack_public_path__ + "static/media/profile-picture.a0129921.jpeg";